import React, {ForwardedRef, forwardRef} from 'react'

import {cn} from '@/src/shared/utils/twMerge'

const Header1 = forwardRef(
  (
    {children, className}: {children: React.ReactNode; className?: string},
    ref: ForwardedRef<HTMLParagraphElement>
  ) => {
    return (
      <h1
        ref={ref}
        className={cn(
          'lg:text-3xl text-2xl font-normal text-gray-900 leading-tight tracking-tight',
          className
        )}>
        {children}
      </h1>
    )
  }
)

Header1.displayName = 'Header1'

export default Header1
